module.exports = __webpack_public_path__ + "img/404.33d1591a.png";